import React from 'react'
import styled, { css } from 'styled-components'

import {
  Button,
  Refresh2Icon,
  Separator as Separator_,
  Typography,
} from '@blade/ui-kit'
import { RectangleNetworkBackground } from '@root/shared/ui'

import type { InfoMessageProps } from './info-message'

export const InfoMessageDt: React.FC<InfoMessageProps> = ({
  className,
  icon,
  onRetry,
  hint,
  title,
  description,
  retryText,
  children,
  withBackground,
  withSeparator = false,
}) => {
  return (
    <Root className={className} $withBackground={withBackground}>
      <IconWrapper>{icon}</IconWrapper>
      <Title>{title}</Title>
      <Description>{description}</Description>
      {withSeparator ? <Separator /> : undefined}

      {onRetry ? (
        <ButtonAlt
          variant="ghost"
          size="xs"
          radius="rounded"
          // color="primary"
          iconLeft={<Refresh2Icon />}
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            onRetry()
          }}
          css={css`
            margin-top: ${withSeparator ? 0 : 8}px;
          `}
        >
          {retryText}
        </ButtonAlt>
      ) : undefined}
      {children}

      {hint ? <Hint>{hint}</Hint> : undefined}
    </Root>
  )
}

const Root = styled.div<{ $withBackground: boolean | undefined }>`
  ${({ $withBackground }) =>
    $withBackground ? RectangleNetworkBackground : undefined}

  color: var(--info-color, var(--textA-10));
  display: grid;

  justify-items: center;
  min-width: 230px;

  place-content: center;
`

const IconWrapper = styled.div`
  color: var(--info-color-title, var(--text-10));
`

const Title = styled(Typography).attrs({
  variant: 'body1-medium',
  component: 'div',
})`
  color: var(--info-color-title, var(--text-10));
  font-size: var(
    --info-size-font-color,
    var(--typography-body-1-medium-font-size)
  );
  text-align: center;
  margin-top: 4px;
`

const Description = styled(Typography).attrs({
  variant: 'body2-regular',
})`
  color: var(--info-color-description, var(--text-8));
  font-size: var(
    --info-size-font-description,
    var(--typography-body-2-regular-font-size)
  );
  text-align: center;
`

const Separator = styled(Separator_)`
  width: 100%;
  margin: 14px 0;
`

const ButtonAlt = styled(Button)`
  border-radius: 6px;
  background: var(--background-3);
`

const Hint = styled(Typography).attrs({
  variant: 'body2-regular',
  component: 'div',
})`
  color: var(--text-12);
  text-align: center;
`
